module.exports = __webpack_public_path__ + "img/18.e5e152b0.png";